import { Typography as NewTypography } from '@mui/joy';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { WhistleReportCustomFieldValue } from './reportDetails';

import { convertIfReadableDate } from '../customer/report/helper';

interface CustomReportValuesProps {
  values: WhistleReportCustomFieldValue[];
}

const CustomReportValues = ({ values }: CustomReportValuesProps) => {
  return (
    <>
      {values.map((value, index) => {
        const joinedValue = Array.isArray(value.value)
          ? value.value.join(', ')
          : value.value;
        if (value.title === 'Red Flags') {
          const redFlags = value.value as string[];
          return (
            <div key={index} className='flex flex-col gap-2'>
              <Typography fontSize={14} fontWeight={500}>
                {value.title}
              </Typography>
              <div className='flex flex-row gap-2'>
                {redFlags.map((flag, flagIndex) => (
                  <div
                    key={flagIndex}
                    className='bg-brand-primary-500 rounded-2xl px-2 py-1'
                  >
                    {flag}
                  </div>
                ))}
              </div>
            </div>
          );
        }
        return (
          <Box key={index} marginY='30px'>
            <Stack spacing={1}>
              <Typography fontSize={14} fontWeight={500}>
                {value.title}
              </Typography>
              <Typography color='#4F4F4F' fontSize={16}>
                {convertIfReadableDate(joinedValue)}
              </Typography>
            </Stack>
            {Object.keys(value.conditional_logic_data).length > 0 &&
              value.conditional_logic_data.conditional_logic_answer && (
                <div className='flex flex-col gap-2 py-3'>
                  <div className='flex justify-between items-center w-full'>
                    <NewTypography color='secondary' level='body-sm'>
                      {value.conditional_logic_data.conditional_logic_title}
                    </NewTypography>
                  </div>
                  <Typography
                    variant='body2'
                    sx={{
                      fontSize: '16px',
                      fontWeight: 400,
                      lineHeight: '24px',
                      textAlign: 'left',
                    }}
                  >
                    {value.conditional_logic_data.conditional_logic_answer}
                  </Typography>
                </div>
              )}
          </Box>
        );
      })}
    </>
  );
};

export default CustomReportValues;
